import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PlayerDialogData, RecommendationsDialogData, UpNextDialogData } from './interfaces/dialogs.interface';
import { MoreLikeThisComponent } from './more-like-this/more-like-this.component';
import { PlayNextComponent } from './play-next/play-next.component';
import { PlayerAudioSubtitlesComponent } from './player-audio-subtitles-dialog/player-audio-subtitles-dialog.component';

/**
 * Open up next dialog
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openUpNextDialog = (dialog: MatDialog, data: UpNextDialogData): Promise<MatDialogRef<PlayNextComponent>> => {
  return dialog
    .open(PlayNextComponent, {
      id: 'play-next-dialog',
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      data,
    })
    .afterClosed()
    .toPromise();
};

/**
 * Open recommendations dialog
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openRecommendationsDialog = (
  dialog: MatDialog,
  data: RecommendationsDialogData
): Promise<MatDialogRef<MoreLikeThisComponent>> => {
  return dialog
    .open(MoreLikeThisComponent, {
      id: 'play-recommendations-dialog',
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      data,
    })
    .afterClosed()
    .toPromise();
};


/**
 * Open player subtitles dialog
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openPlayerSubtitlesDialog = (
  dialog: MatDialog,
  data: PlayerDialogData
): Promise<MatDialogRef<PlayerAudioSubtitlesComponent>> => {
  return dialog
    .open(PlayerAudioSubtitlesComponent, {
      maxWidth: '100vw',
      width: '100%',
      height: '100%',
      autoFocus: false,
      data,
      ariaLabel: data.dialogDescription,
    })
    .afterClosed()
    .toPromise();
};

